import Dialog from '@material-ui/core/Dialog';
import { createStyles } from '@material-ui/core/styles';
import { withStyles } from '@material-ui/styles';
import { ActionIcon, Text } from '@topconagriculture/react-components';
import { toCssValue } from '@topconagriculture/theme';
import * as React from 'react';
import { connect } from 'react-redux';
import { compose, pure } from 'recompose';
import { withModal } from '../../hocs';
import { getCloseModalButtonIsVisible, getDialogProps, getModalIsVisible, getModalRequested, getModalTitle, } from '../../store';
const styles = (theme) => createStyles({
    closeIcon: {
        cursor: 'pointer',
        position: 'absolute',
        right: 20,
        top: 20,
        zIndex: 999,
    },
    modalHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: toCssValue([20, 50, 20, 20]),
        paddingBottom: 0,
    },
    modalWrapper: {
        borderRadius: theme.common.borderRadius.default,
        overflowY: 'auto',
    },
    scrollBodyWrapper: {
        display: 'grid',
    },
});
let modalsMap = {};
export const configureModalMap = (modalConfig) => {
    modalsMap = { ...modalsMap, ...modalConfig };
};
const ModalContainer = (props) => {
    const { classes, closeModal, modalIsVisible, modalRequested, dialogProps, modalTitle, closeModalButtonIsVisible, } = props;
    const modalComponent = modalsMap[modalRequested];
    return (React.createElement(Dialog, { classes: { paper: classes.modalWrapper, scrollBody: classes.scrollBodyWrapper }, ...dialogProps, open: dialogProps && typeof dialogProps.open === 'boolean' ? dialogProps.open : modalIsVisible },
        modalTitle ? (React.createElement("div", { className: classes.modalHeader },
            React.createElement(Text, { block: true, bold: true, size: 18, testId: 'modal-title' }, modalTitle),
            closeModalButtonIsVisible && (React.createElement(ActionIcon, { className: classes.closeIcon, iconName: "close", onClick: closeModal, iconSize: 16, testId: 'button-close' })))) : (closeModalButtonIsVisible && (React.createElement(ActionIcon, { className: classes.closeIcon, iconName: "close", onClick: closeModal, iconSize: 16, testId: 'button-close' }))),
        modalComponent));
};
const mapStateToProps = (state) => ({
    closeModalButtonIsVisible: getCloseModalButtonIsVisible(state),
    dialogProps: getDialogProps(state),
    modalIsVisible: getModalIsVisible(state),
    modalRequested: getModalRequested(state),
    modalTitle: getModalTitle(state),
});
const ComposedModalContainer = compose(connect(mapStateToProps), withStyles(styles, { withTheme: true }), pure, withModal)(ModalContainer);
ComposedModalContainer.displayName = 'ModalContainer';
export default ComposedModalContainer;
//# sourceMappingURL=ModalContainer.js.map